import { Card, Flex, Grid, Text } from '@servicetitan/anvil2';
import { DataItem } from '@servicetitan/financing-utils-shared';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import {
    PrequalificationResponseStore,
    SetupDataStore,
} from '@servicetitan/financing-workflow-shared';
import { DecisionDataStore } from '../stores/DecisionDataStore';

/**
 * Summary of who applied and when, shown on the declined page in place of loan terms. The id names
 * the application that was declined, which for a dual decline is still the first look because the
 * second look leaves the original decision data in place.
 */
export const ApplicationDetails = () => {
    const { decisionData } = DecisionDataStore.useStore();
    const { applicationData } = ApplicationDataStore.useStore();
    const { prequalificationResponse } = PrequalificationResponseStore.useStore();
    const { setupData } = SetupDataStore.useStore();

    const primaryApplicant = applicationData?.applicant?.primaryApplicant;
    const applicantName = [primaryApplicant?.firstName, primaryApplicant?.lastName]
        .filter(Boolean)
        .join(' ');

    // A soft prequal decision arrives with its externalPrequalId already mapped onto
    // externalLoanId (see useFinancingPrequalSubmission), so this field always names the
    // application that produced the decision on screen.
    const applicationId = decisionData?.externalLoanId;

    // Nothing clears the prequal response when a soft prequal continues into a hard app, so its
    // presence alone can't say what the id above is. Once the hard app has taken over, the id is a
    // loan id and calling it a pre-qualification would be wrong.
    const isSoftPrequal =
        !!prequalificationResponse?.externalPrequalId && !setupData?.hasTransitionedToHardApp;
    const applicationIdLabel = isSoftPrequal ? 'Pre-Qualification ID' : 'Application ID';

    return (
        <Card flexDirection="column" style={{ maxWidth: '845px', width: '100%' }}>
            <Flex gap="3" direction="column">
                <Text variant="headline" el="h2" size="small">
                    Application Details
                </Text>
                {/* Same auto-fit columns as LoanDetails: fills the card width, and drops to fewer
                    columns rather than overflowing on a narrow viewport. */}
                <Grid rowGap="4" templateColumns="repeat(auto-fit, minmax(255px, 1fr))">
                    <DataItem label="Applicant Name" text={applicantName} />
                    <DataItem label="Date" text={new Date().toLocaleDateString()} />
                    <DataItem label={applicationIdLabel} text={applicationId} />
                </Grid>
            </Flex>
        </Card>
    );
};
